var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,3,21,5.7a.23.23,0,0,1-.17.07l-2.26-.08a.24.24,0,0,1-.23-.22l-.11-2.29A.24.24,0,0,1,18.3,3L21,.3A4.57,4.57,0,0,0,19.38,0a4.61,4.61,0,0,0-4.59,5.14.23.23,0,0,1-.07.19L5.28,14.77a.22.22,0,0,1-.19.06c-.23,0-.45,0-.67,0a4.12,4.12,0,0,0-3.11,1.37A4.93,4.93,0,0,0,.25,21.05L3,18.35a.21.21,0,0,1,.18-.07l2.29.11a.22.22,0,0,1,.22.22l.08,2.26a.26.26,0,0,1-.07.17L3,23.75a4.63,4.63,0,0,0,1.5.25,4.89,4.89,0,0,0,3.39-1.31,4.2,4.2,0,0,0,1.33-3.78.23.23,0,0,1,.07-.19l9.43-9.44a.26.26,0,0,1,.19-.07l.52,0a4.59,4.59,0,0,0,3.27-1.35A4.66,4.66,0,0,0,23.71,3Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.6ee5fe52.svg";
export { ForwardRef as ReactComponent };